import { processOpenActionRequest } from '../open-action-helper';
import type { Action } from '../../store/state/state-manager';

export const processOpenLocalActionRequest = (
  actionInPayload: Action['payload'],
  options: { isProcessAction?: boolean; actionMgrID?: number }
) => {
  return processOpenActionRequest(actionInPayload, options);
};

export default {
  processOpenLocalActionRequest
};
